import { render } from "./modelInfo.vue?vue&type=template&id=71cc9f54&scoped=true"
import script from "./modelInfo.vue?vue&type=script&lang=js"
export * from "./modelInfo.vue?vue&type=script&lang=js"

import "./modelInfo.vue?vue&type=style&index=0&id=71cc9f54&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cc9f54"]])

export default __exports__